export default __webpack_public_path__ + "static/media/carousel3.0517e032.jpg";